import {
  Flex,
  Text,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  AccordionItemProps,
  Icon,
} from '@chakra-ui/react';
import { ariaAttr } from '@chakra-ui/utils';
import { FC, Fragment } from 'react';

import PlayButton from '@/assets/icons/ic-play-button-32.svg';

import { OriginalsEpisode } from '@/resources/OriginalsEpisode';

interface IEpisodeCardProps extends AccordionItemProps {
  episode: OriginalsEpisode;
  isPlaying?: boolean;
  onPlayClick?: (episodeId: string | null) => void;
}

export const EpisodeBar: FC<IEpisodeCardProps> = ({ isPlaying = false, episode, onPlayClick, ...props }) => {
  function handlePlayButtonClick(e) {
    e.stopPropagation();
    onPlayClick(episode.id);
  }

  return (
    <AccordionItem
      borderRadius="5px"
      border="0"
      bg="gray.100"
      aria-selected={ariaAttr(isPlaying)}
      mb={4}
      _selected={{
        bg: 'gradientBackground',
        color: 'white',
      }}
      {...props}
    >
      {({ isExpanded }) => (
        <Fragment>
          <AccordionButton _hover={{ bg: 'auto' }} minH="64px">
            <Flex justifyContent="space-between" w="full" alignItems="center">
              <Icon w="32px" h="32px" onClick={handlePlayButtonClick} cursor="pointer" as={PlayButton} />
              <Text
                fontWeight="500"
                minW="0"
                noOfLines={!isExpanded && 1}
                flex="1"
                ml={{ base: 4, md: 8 }}
                mr="auto"
                textAlign="left"
              >
                {episode.title}
              </Text>
              <Text mr={{ base: 2, md: 4 }}>{episode.duration}</Text>
            </Flex>
            <AccordionIcon fontSize="2xl" />
          </AccordionButton>
          <AccordionPanel>
            <Text mx={16} fontSize="14px">
              {episode.description}
            </Text>
          </AccordionPanel>
        </Fragment>
      )}
    </AccordionItem>
  );
};
